import React from 'react'
import { DraftBoardContainer } from './styles'
import { PlayerList } from './PlayerList'
import { DraftBoardHeader } from './DraftBoardHeader'
import { Con } from '../../../Components/Layout/Containers/ConStyles'

type DraftBoardViewProps = {
  showProfilePicture?: boolean
  fullHeight?: boolean
}

export const DraftBoardView: React.FC<DraftBoardViewProps> = ({ showProfilePicture = true, fullHeight = true }) => {
  return (
    <Con sideMargins={2} vertMargins={2} direction='column'>
      <DraftBoardHeader showProfilePicture={showProfilePicture} />
      <DraftBoardContainer>
        <PlayerList fullHeight={fullHeight} />
      </DraftBoardContainer>
    </Con>
  )
}
